/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
// global font
// eslint-disable-next-line quotes
export var prometheanFont = "'Noto Sans', sans-serif, BlinkMacSystemFont, system-ui, -apple-system";